/*******************************************************************************

Copyright (c) 2017-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*******************************************************************************/

// @format
// Stock tools overrides

import highed from './../globals';
import Events from './../core/highed.events';
import { nodefault, on } from './../core/highed.dom';
import {
  addAnnotationAction,
  removeAnnotationAction,
  updateAnnotationsAction,
  showAnnotationInMenuAction
} from '../../pages/ChartEditorPage/actions/chartEditor';
import store from './../../redux/store';

export default () => {
  let popup,
    events = Events(),
    showAnnotationIcon = true,
    annotationModalOpen = false,
    dragging = false,
    popupContainer,
    labelControlPointsProp = (H) => [
      {
        symbol: 'triangle-down',
        positioner: function (target) {
          if (!target.graphic.placed) {
            return {
              x: 0,
              y: -9e7
            };
          }

          let xy = H.Annotation.MockPoint.pointToPixels(target.points[0]);

          return {
            x: xy.x - this.graphic.width / 2,
            y: xy.y - this.graphic.height / 2
          };
        },

        // TRANSLATE POINT/ANCHOR
        events: {
          drag: function (e, target) {
            let xy = this.mouseMoveToTranslation(e);

            target.translate(-xy.x, -xy.y);
            target.translatePoint(xy.x, xy.y);

            target.annotation.labels[0].options = target.options;

            target.redraw(false);
          },
          mouseup: function () {
            store.dispatch(updateAnnotationsAction());
          }
        }
      },
      {
        symbol: 'circle',
        positioner: function (target) {
          if (!target.graphic.placed) {
            return {
              x: 0,
              y: -9e7
            };
          }

          return {
            x: target.graphic.alignAttr.x - this.graphic.width / 2,
            y: target.graphic.alignAttr.y - this.graphic.height / 2
          };
        },

        // TRANSLATE POSITION WITHOUT CHANGING THE
        // ANCHOR
        events: {
          drag: function (e, target) {
            let xy = this.mouseMoveToTranslation(e);

            target.translatePoint(xy.x, xy.y);

            target.annotation.labels[0].options = target.options;

            target.redraw(false);
          },
          mouseup: function () {
            store.dispatch(updateAnnotationsAction());
          }
        }
      }
    ],
    stockToolsToolbarConfig = {
      stockTools: {
        gui: {
          buttons: ['simpleShapes', 'lines'],
          enabled: false
        }
      },
      navigationBindings: {},
      navigation: {
        events: {
          // On selecting the annotation the showPopup event is fired
          showPopup: function (event) {
            //Load annotation in sidemenu
            const annotation = event.annotation;
            const annotations = this.chart.annotations || [];

            const index = annotations.findIndex((c) => c === annotation);
            store.dispatch(
              showAnnotationInMenuAction({
                type: annotation.labels && annotation.labels.length > 0 ? 'label' : 'shape',
                index,
                annotation
              })
            );

            if (!this.chart.indicatorsPopupContainer) {
              this.chart.indicatorsPopupContainer = document.getElementsByClassName('highcharts-popup-indicators')[0];
            }
            /*
          if (!this.chart.annotationsPopupContainer) {
            this.chart.annotationsPopupContainer = document
              .getElementsByClassName('highcharts-popup-annotations')[0];
          }*/

            if (event.formType === 'indicators') {
              this.chart.indicatorsPopupContainer.style.display = 'block';
            } else if (event.formType === 'annotation-toolbar') {
              // If user is still adding an annotation, don't show popup:
              if (!this.chart.activeButton) {
                this.chart.currentAnnotation = event.annotation;
                //  this.chart.annotationsPopupContainer.style.display = 'block';
              }
            }

            if (this.popup) {
              popup = this.popup;
            }
          },
          closePopup: function () {
            // Hide the popup container, and reset currentAnnotation
            // this.chart.annotationsPopupContainer.style.display = 'none';
            this.chart.currentAnnotation = null;
          },
          selectButton: function (event) {
            let newClassName = event.button.className + ' highcharts-active';

            if (event.button.classList.contains('highcharts-active')) return;

            event.button.className = newClassName;

            // Store info about active button:
            this.chart.activeButton = event.button;
          },
          deselectButton: function (event) {
            if (event.button) event.button.classList.remove('highcharts-active');
            // Remove info about active button:
            this.chart.activeButton = null;
          }
        },
        bindingsClassName: 'tools-container'
      }
    },
    position = {
      x: 0,
      y: 0
    },
    timeout = null;

  function closeAnnotationPopup() {
    if (popup) {
      popup.closePopup();
    }
    annotationModalOpen = false;
  }

  function toggleAnnotationIcon(toggle) {
    showAnnotationIcon = toggle;
  }

  function getStockToolsToolbarConfig() {
    return stockToolsToolbarConfig;
  }

  function hideTooltip() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }

    this.chart.update({
      tooltip: {
        enabled: false
      }
    });
  }

  function showTooltip() {
    let chart = this.chart;
    timeout = setTimeout(function () {
      chart.update({
        tooltip: {
          enabled: true
        }
      });
    }, 1000);
  }

  function getAnnotationModalOpen() {
    return annotationModalOpen;
  }

  function init(H) {
    function selectableAnnotation(annotationType) {
      let originalClick =
        annotationType.prototype.defaultOptions.events && annotationType.prototype.defaultOptions.events.click;

      function selectAndshowPopup(event) {
        let annotation = this,
          navigation = annotation.chart.navigationBindings,
          prevAnnotation = navigation.activeAnnotation;

        if (originalClick && originalClick.click) {
          originalClick.click.call(annotation, event);
        }

        if (prevAnnotation !== annotation) {
          // Select current:
          navigation.deselectAnnotation();

          navigation.activeAnnotation = annotation;
          annotation.setControlPointsVisibility(true);

          H.fireEvent(navigation, 'showPopup', {
            annotation: annotation,
            formType: 'annotation-toolbar',
            options: navigation.annotationToFields(annotation),
            onSubmit: function (data) {
              let config = {},
                typeOptions;

              if (data.actionType === 'remove') {
                navigation.activeAnnotation = false;
                navigation.chart.removeAnnotation(annotation);
              } else {
                navigation.fieldsToOptions(data.fields, config);
                navigation.deselectAnnotation();

                typeOptions = config.typeOptions;

                if (annotation.options.type === 'measure') {
                  // Manually disable crooshars according to
                  // stroke width of the shape:
                  typeOptions.crosshairY.enabled = typeOptions.crosshairY.strokeWidth !== 0;
                  typeOptions.crosshairX.enabled = typeOptions.crosshairX.strokeWidth !== 0;
                }

                annotation.update(config);
              }
            }
          });
        } else {
          // Deselect current:
          navigation.deselectAnnotation();
          H.fireEvent(navigation, 'closePopup');
        }
        // Let bubble event to chart.click:
        event.activeAnnotation = true;

        return nodefault(event);
      }

      H.merge(true, annotationType.prototype.defaultOptions.events, {
        contextmenu: selectAndshowPopup,
        mouseover: hideTooltip,
        mouseleave: showTooltip,
        mouseup: function (event) {
          position.x = event.layerX;
          position.y = event.layerY;
        }
      });
    }

    if (H.Annotation) {
      // Basic shapes:
      selectableAnnotation(H.Annotation);

      // Advanced annotations:
      H.objectEach(H.Annotation.types, function (annotationType) {
        selectableAnnotation(annotationType);
      });
    }

    H.Toolbar.prototype.showHideToolbar = function () {
      let stockToolbar = this,
        chart = this.chart,
        wrapper = stockToolbar.wrapper,
        toolbar = this.listWrapper,
        submenu = this.submenu,
        visible = this.visible,
        PREFIX = 'highcharts-',
        DIV = 'div',
        createElement = H.createElement,
        showhideBtn;

      // Show hide toolbar
      this.showhideBtn = showhideBtn = createElement(
        DIV,
        {
          className: PREFIX + 'toggle-toolbar ' + (visible ? ' active' : ' inactive')
        },
        null,
        wrapper
      );

      if (!visible) {
        // hide
        if (submenu) {
          submenu.style.display = 'none';
        }
        stockToolbar.visible = visible = false;

        toolbar.classList.add(PREFIX + 'hide');
        wrapper.style.height = showhideBtn.offsetHeight + 'px';

        this.showhideBtn.innerHTML =
          '<span><span class="fa fa-chevron-up"></span><i class="fas fa-marker"></i><span class="fa fa-chevron-down"></span><span class="tooltip">Annotate Chart</span></span>';
      } else {
        wrapper.style.height = '100%';
        this.showhideBtn.innerHTML =
          '<span><span class="fa fa-chevron-up"></span> <i class="fas fa-marker"></i> <span class="fa fa-chevron-down"/></span>';
      }

      stockToolbar.listWrapper.style.height = 'calc(100% - 90px)';

      // toggle menu
      ['click', 'touchstart'].forEach(function (eventName) {
        H.addEvent(showhideBtn, eventName, function () {
          chart.update({
            stockTools: {
              gui: {
                visible: !visible,
                placed: true
              }
            }
          });
        });
      });
    };

    H.Annotation.ControlPoint.prototype.redraw = function (animation) {
      this.graphic[animation ? 'animate' : 'attr'](
        this.options.positioner ? this.options.positioner.call(this, this.target) : null
      );
    };

    H.setOptions({
      navigation: {
        annotationsOptions: {
          events: {
            afterUpdate: function (e, d, g) {
              store.dispatch(updateAnnotationsAction());
              /*
                const annotation = this;
                const annotations = this.chart.annotations || [];
                const index = annotations.findIndex((c) => c === annotation);
                events.emit("ShowAnnotationInMenu", annotation.labels && annotation.labels.length > 0 ? 'label' : 'shape', index, annotation);*/
            },
            remove: function () {
              //Give some time for highcharts to delete the annotation from the chart
              const annotation = this;
              const annotations = this.chart.annotations || [];
              const index = annotations.findIndex((c) => c === annotation);
              setTimeout(function () {
                /*
                    store.dispatch(removeAnnotationAction({
                      type: annotation.labels && annotation.labels.length > 0 ? 'label' : 'shape', 
                      index, 
                      annotation
                    }));*/
              }, 100);
            },
            add: function () {
              //Give some time for highcharts to add the annotation to the chart
              //Highcharts, for some reason, calls the add event on first click of the line annotation
              const annotation = this;
              const annotations = this.chart.annotations || [];
              const index = annotations.findIndex((c) => c === annotation);
              const isLabel = annotation.labels && annotation.labels.length > 0;
              if (isLabel) {
                setTimeout(function () {
                  store.dispatch(
                    addAnnotationAction({
                      type: annotation.labels && annotation.labels.length > 0 ? 'label' : 'shape',
                      index,
                      annotation
                    })
                  );
                }, 100);
              } else {
                const chart = annotation.chart;
                const addLine = function (e) {
                  store.dispatch(
                    addAnnotationAction({
                      type: annotation.labels && annotation.labels.length > 0 ? 'label' : 'shape',
                      index,
                      annotation
                    })
                  );
                  chart.container.removeEventListener('click', addLine);
                };
                chart.container.addEventListener('click', addLine);
              }
            }
          },
          labelOptions: {
            format: 'Insert Text'
          }
        },
        bindings: {
          labelAnnotation: {
            start: function (e) {
              let coords = this.chart.pointer.getCoordinates(e),
                type = 'label',
                navigation = this.chart.options.navigation,
                bindings = navigation && navigation.bindings;

              this.chart.addAnnotation(
                H.merge(
                  {
                    langKey: 'label',
                    labelOptions: {
                      format: '{y:.2f}'
                    },
                    labels: [
                      {
                        shape: 'evervizCallout',
                        point: {
                          x: coords.xAxis[0].value,
                          y: coords.yAxis[0].value,
                          xAxis: 0,
                          yAxis: 0
                        },
                        controlPoints: labelControlPointsProp(H),
                        overflow: 'none',
                        crop: true
                      }
                    ]
                  },
                  navigation.annotationsOptions,
                  bindings[type] && bindings[type].annotationsOptions
                )
              );
            }
          }
        }
      }
    });

    H.Annotation.prototype.onMouseUp = function (event) {
      let chart = this.chart,
        annotation = this.target || this,
        annotationsOptions = chart.options.annotations,
        index = chart.annotations.indexOf(annotation);

      if (popupContainer) {
        popupContainer.style.opacity = 1.0;
      }

      this.removeDocEvents();
      annotationsOptions[index] = annotation.options;
      //events.emit("StockToolsChanged", annotation.options, index, "AnnotationMoved");
      store.dispatch(updateAnnotationsAction());
    };

    H.Annotation.ControlPoint.prototype.addEvents = function () {
      let emitter = this;

      H.addEvent(emitter.graphic.element, 'mousedown', function (e) {
        emitter.onMouseDown(e);
      });

      emitter.options.events.mouseover = hideTooltip;
      emitter.options.events.mouseleave = showTooltip;

      H.objectEach(emitter.options.events, function (event, type) {
        let eventHandler = function (e) {
          if (type !== 'click' || !emitter.cancelClick) {
            event.call(emitter, emitter.chart.pointer.normalize(e), emitter.target);
          }
        };

        if (H.inArray(type, emitter.nonDOMEvents || []) === -1) {
          emitter.graphic.on(type, eventHandler);
        } else {
          H.addEvent(emitter, type, eventHandler);
        }
      });

      if (emitter.options.draggable) {
        H.addEvent(emitter, 'drag', emitter.onDrag);

        if (!emitter.graphic.renderer.styledMode) {
          emitter.graphic.css({
            cursor: {
              x: 'ew-resize',
              y: 'ns-resize',
              xy: 'move'
            }[emitter.options.draggable]
          });
        }
      }

      if (!emitter.isUpdating) {
        H.fireEvent(emitter, 'add');
      }
    };

    H.Annotation.ControlPoint.prototype.onMouseDown = function (e) {
      let emitter = this,
        pointer = emitter.chart.pointer,
        prevChartX,
        prevChartY;

      dragging = true;

      if (popupContainer) {
        popupContainer.style.opacity = 0.2;
      }
      if (e.preventDefault) {
        e.preventDefault();
      }

      // On right click, do nothing:
      if (e.button === 2) {
        return;
      }

      e = pointer.normalize(e);
      prevChartX = e.chartX;
      prevChartY = e.chartY;

      emitter.cancelClick = false;

      emitter.removeDrag = H.addEvent(H.doc, 'mousemove', function (e) {
        emitter.hasDragged = true;

        e = pointer.normalize(e);
        e.prevChartX = prevChartX;
        e.prevChartY = prevChartY;

        H.fireEvent(emitter, 'drag', e);

        prevChartX = e.chartX;
        prevChartY = e.chartY;
      });

      emitter.removeMouseUp = H.addEvent(H.doc, 'mouseup', function (e) {
        emitter.cancelClick = emitter.hasDragged;
        emitter.hasDragged = false;
        // ControlPoints vs Annotation:
        H.fireEvent(H.pick(emitter.target, emitter), 'afterUpdate');
        emitter.onMouseUp(e);
      });
    };

    H.Annotation.prototype.onDrag = function (e) {
      if (popupContainer) {
        popupContainer.style.opacity = 0.2;
      }

      if (this.chart.isInsidePlot(e.chartX - this.chart.plotLeft, e.chartY - this.chart.plotTop)) {
        let translation = this.mouseMoveToTranslation(e);

        if (this.options.draggable === 'x') {
          translation.y = 0;
        }

        if (this.options.draggable === 'y') {
          translation.x = 0;
        }

        if (this.points.length) {
          this.translate(translation.x, translation.y);
        } else {
          this.shapes.forEach(function (shape) {
            shape.translate(translation.x, translation.y);
          });
          this.labels.forEach(function (label) {
            label.translate(translation.x, translation.y);
          });
        }

        this.redraw(false);
      }
    };

    H.Annotation.ControlPoint.prototype.onMouseUp = function () {
      let chart = this.chart,
        annotation = this.target.annotation || this,
        annotationsOptions = chart.options.annotations,
        index = chart.annotations.indexOf(annotation);

      dragging = false;

      if (popupContainer) {
        popupContainer.style.opacity = 1.0;
      }

      if (
        annotation.target &&
        annotation.target.options &&
        (annotation.target.options.type === 'crookedLine' ||
          annotation.target.options.type === 'infinityLine' ||
          annotation.target.options.type === 'elliottWave')
      ) {
        //annotationsOptions[index].typeOptions.points = annotation.target.points;
        events.emit('StockToolsChanged', annotation.target.points, index, 'AnnotationHandleMoved');
      } else if (
        annotation.options &&
        (annotation.options.langKey === 'rectangle' || annotation.options.langKey === 'circle')
      ) {
        events.emit('StockToolsChanged', annotation.shapes[0].options.point, index, 'AnnotationHandleMoved');
      } else {
        if (annotationsOptions[index]) annotationsOptions[index].labels[0].point = annotation.labels[0].options.point;
        events.emit('StockToolsChanged', annotation.labels[0].options.point, index, 'AnnotationHandleMoved');
      }

      this.removeDocEvents();
    };

    // Comunication with bindings:

    const NavigationBindings = H._modules['Extensions/Annotations/NavigationBindings.js'];

    if (NavigationBindings) {
      //Hide tooltip if adding annotation.

      H.addEvent(NavigationBindings, 'selectButton', function (event) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }

        this.chart.update({
          tooltip: {
            enabled: false
          }
        });
      });

      H.addEvent(NavigationBindings, 'deselectButton', function (event) {
        let chart = this.chart;
        timeout = setTimeout(function () {
          chart.update({
            tooltip: {
              enabled: true
            }
          });
        }, 1000);
      });

      NavigationBindings.prototype.bindingsButtonClick = function (button, events, clickEvent) {
        var navigation = this,
          chart = navigation.chart,
          svgContainer = chart.renderer.boxWrapper;
        var shouldEventBeFired = true;
        var PREFIX = 'highcharts-';

        if (navigation.selectedButtonElement) {
          if (navigation.selectedButtonElement.classList === button.classList) {
            shouldEventBeFired = false;
          }
          H.fireEvent(navigation, 'deselectButton', { button: navigation.selectedButtonElement });
          if (navigation.nextEvent) {
            // Remove in-progress annotations adders:
            if (navigation.currentUserDetails && navigation.currentUserDetails.coll === 'annotations') {
              chart.removeAnnotation(navigation.currentUserDetails);
            }
            navigation.mouseMoveEvent = navigation.nextEvent = false;
          }
        }
        if (shouldEventBeFired) {
          navigation.selectedButton = events;
          navigation.selectedButtonElement = button;
          H.fireEvent(navigation, 'selectButton', { button: button });
          // Call "init" event, for example to open modal window
          if (events.init) {
            events.init.call(navigation, button, clickEvent);
          }
          if (events.start || events.steps) {
            chart.renderer.boxWrapper.addClass(PREFIX + 'draw-mode');
          }
        } else {
          chart.stockTools && chart.stockTools.toggleButtonAciveClass(button);
          svgContainer.removeClass(PREFIX + 'draw-mode');
          navigation.nextEvent = false;
          navigation.mouseMoveEvent = false;
          navigation.selectedButton = null;
        }
      };
    }
  }

  function getLabelControlPointsProps() {
    return labelControlPointsProp(Highcharts);
  }

  ///////////////////////////////////////////////////////////////////////////

  return {
    init: init,
    closeAnnotationPopup: closeAnnotationPopup,
    getStockToolsToolbarConfig: getStockToolsToolbarConfig,
    toggleAnnotationIcon: toggleAnnotationIcon,
    on: events.on,
    getAnnotationModalOpen: getAnnotationModalOpen,
    getLabelControlPointsProps: getLabelControlPointsProps
  };
};
